export enum ProductType {
  CreatorsPicks = "creators-picks",
  DallasCreatorPicks = "dallas-creator-picks",
  TTProduct = "tt-product",
  ProductDetailRecommend = "product-detail-recommend",
  LAProducts = "la-products",
  HotProducts = "hot-products",
  TopCommission = "top-commission",
}

export enum PerformanceType {
  /** 畅销榜 */
  PerformanceTopSelling = 1,
}

export enum ProductTrendType {
  /** 销量 */
  UnitsSold = "1",
  /** GMV */
  GMV = "2",
}

export enum ProductDateType {
  /** 7 天 */
  Days_7 = "1",
  /** 28 天 */
  Days_28 = "2",
}
